module.exports = __webpack_public_path__ + "media/images/front/menu_db02-a2a1dfcd96c2bd5b0a795f280ee0437c.jpg";